<template>
  <div class="chat-widget d-flex flex-column h-100">
    <div class="chat-widget__messages flex-grow-1 mb-2">
      <div v-for="msg in messages" :key="msg.id" class="chat-widget__msg small mb-1">
        <strong>{{ msg.sender?.name || 'User' }}:</strong> {{ msg.message }}
      </div>
    </div>
    <div class="input-group input-group-sm">
      <input v-model="text" class="form-control" placeholder="Message..." @keyup.enter="send" />
      <div class="input-group-append">
        <button class="btn btn-primary" @click="send">Send</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: { config: { type: Object, default: () => ({}) } },
  data() { return { text: '' } },
  computed: { ...mapGetters('mission', ['messages']) },
  mounted() { this.fetchMessages() },
  methods: {
    ...mapActions('mission', ['fetchMessages', 'sendMessage']),
    async send() {
      if (!this.text.trim()) return
      const payload = { message: this.text }
      if (this.config.target && this.config.target !== 'all') {
        payload.node_id = this.config.target
      }
      await this.sendMessage(payload)
      this.text = ''
    },
  },
}
</script>

<style scoped>
.chat-widget__messages {
  overflow-y: auto;
  max-height: 200px;
  color: var(--ws-text);
}
.chat-widget__msg {
  color: var(--ws-text);
}
</style>
